import './Footer.css'
import { FaLinkedinIn, FaInstagram, FaFacebookF } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
const Footer = () => {
    return (
        <footer id="footer" className="footer md-pb-70">
            <div className="footer-wrap">
                <div className="footer-body">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-md-6 col-12">
                                <div className="footer-infor">
                                    <div className="footer-logo">
                                        <Link to="/">
                                            <img src="./Royalhoodlogo2.png" alt="" style={{ height: "100px" }} />
                                        </Link>
                                    </div>
                                    <ul>
                                        <li style={{ fontFamily: 'Jost' }}>
                                            <p><FaMapMarkerAlt /> #29, 1st Floor, BTM 2nd Stage,<br /> Bannerghatta Main Road,<br /> Opposite To Gopalan Mall,<br /> Next Jayadeva Metro Station,<br /> Bangalore - 560076</p>
                                        </li>
                                        <li style={{ fontFamily: 'Jost' }}>
                                            <p><IoMdMail /><Link style={{ marginLeft: "2%",color:"white" }} to="mailto:support@royalhood.in">support@royalhood.in</Link></p>
                                        </li>
                                        <li style={{ fontFamily: 'Jost' }}>
                                            <p><FaPhoneAlt /> <Link style={{ marginLeft: "2%",color:"white" }} to="tel:+919620072626">+91 9620072626</Link></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-md-6 col-12 footer-col-block">
                                <div className="footer-heading footer-heading-desktop">
                                    <h4>Help</h4>
                                </div>
                                <div className="footer-heading footer-heading-moblie">
                                    <h4>Help</h4>
                                </div>
                                <ul className="footer-menu-list tf-collapse-content">
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/Privacy-Policy" className="footer-menu_item" style={{color:"white"}}>Privacy Policy</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/Cancellations&Refunds" className="footer-menu_item" style={{color:"white"}}>  Cancellations and Refunds</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/RentalAgreement" className="footer-menu_item" style={{color:"white"}}>Rental Agreement</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/Shipping-Policy" className="footer-menu_item" style={{color:"white"}}>Shipping-Policy</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/Terms&Conditions" className="footer-menu_item" style={{color:"white"}}>Terms &amp; Conditions</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/FAQs" className="footer-menu_item" style={{color:"white"}}>FAQ’s</Link>
                                    </li>
                                  
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 col-12 footer-col-block">
                                <div className="footer-heading footer-heading-desktop">
                                    <h4>About us</h4>
                                </div>
                                <div className="footer-heading footer-heading-moblie">
                                    <h4>About us</h4>
                                </div>
                                <ul className="footer-menu-list tf-collapse-content">
                                   
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="https://maps.app.goo.gl/1nWRpbK1Sz1DmVaE9" target="_blank" className="footer-menu_item" style={{color:"white"}}>Visit Our Store</Link>
                                    </li>
                                    <li style={{ fontFamily: 'Jost',color:"white" }}>
                                        <Link to="/contactus" className="footer-menu_item" style={{color:"white"}}>Contact Us</Link>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 col-12">
                                <div className="footer-newsletter footer-col-block">
                                   
                                    <div className="tf-collapse-content">
                                        
                                        <p style={{color:"white"}}>Connect with Us</p>

                                        <div style={{ display: 'flex', zIndex: 100, marginTop: "10px" }}>


                                            <Link to="https://www.linkedin.com/in/royalhood-in-0b1561346?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" className="icons" style={{ fontFamily: 'Jost' }}><FaLinkedinIn color='white' /></Link>

                                            <Link to="https://www.instagram.com/royalhood.in?igsh=M2Rtd3V2dHl2dzBq" target="_blank" className="icons" style={{ fontFamily: 'Jost' }}><FaInstagram color='white' /> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                                    <div className="footer-menu_item" style={{ fontFamily: 'Jost' }}>© 2024 Royal Hood. All Rights Reserved</div>
                                    <div className="tf-payment">
                                        <Link to="https://excerptech.com/" target="_blank" >Designed By Excerpt Technologies</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;